/* eslint-disable import/prefer-default-export */
import { SHOW_SEARCH_RESULTS } from '../constants/ActionTypes';

export function showSearchResults() {
  return { type: SHOW_SEARCH_RESULTS };
}
